import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Leaf, Shield } from "lucide-react";

const benefits = [
  {
    title: "Experienced Technicians",
    description: "Our certified pool professionals have years of experience maintaining pools in sunny climates.",
    icon: Users,
    testimonial: "BlueLux has been maintaining our pool. Their team is reliable and professional!",
    author: "Sarah M."
  },
  {
    title: "Eco-Friendly Chemicals",
    description: "We use only the highest quality, environmentally safe chemicals that are gentle on your family and pets.",
    icon: Leaf,
    testimonial: "Love that they use eco-friendly products. My kids can swim safely without harsh chemicals.",
    author: "Mike D."
  },
  {
    title: "Satisfaction Guarantee",
    description: "We stand behind our work with a 100% satisfaction guarantee. If you're not happy, we'll make it right.",
    icon: Shield,
    testimonial: "Their satisfaction guarantee gives me peace of mind. They always go above and beyond.",
    author: "Jennifer L."
  }
];

export const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-16 bg-blue-dark/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-primary">
            Why Choose BlueLux?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the difference that professional pool care makes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <Card key={index} className="text-center bg-card/30 backdrop-blur border-primary/20 hover:border-primary/40 transition-all duration-300 hover:scale-105">
                <CardHeader className="pb-4">
                  <div className="flex justify-center mb-4">
                    <div className="bg-primary/10 p-4 rounded-full">
                      <IconComponent size={48} className="text-primary" />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-bold text-primary">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground mb-6">
                    {benefit.description}
                  </p>
                  
                  <div className="bg-gradient-to-br from-primary/10 to-accent/10 p-4 rounded-lg">
                    <div className="flex justify-center mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="text-gold text-lg">★</span>
                      ))}
                    </div>
                    <p className="text-sm italic text-muted-foreground mb-2">
                      "{benefit.testimonial}"
                    </p>
                    <p className="text-sm font-semibold text-primary">
                      - {benefit.author}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};